import axios, { type AxiosInstance, type AxiosRequestConfig } from "axios";

import httpAdapter from "axios/lib/adapters/http";

export const createHttpClient = (params: AxiosRequestConfig = {}): AxiosInstance => {
	const inst = axios.create({
		adapter: httpAdapter,
		...params,
	});

	inst.interceptors.request.use(
		(config: AxiosRequestConfig) => {
			return config;
		},
		(error) => {
			return Promise.reject(error);
		},
	);

	inst.interceptors.response.use(
		(response) => {
			return response;
		},
		(error) => {
			return Promise.reject(error);
		},
	);

	return inst;
};
